import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "../push/plugin";
import { captureSentryMessage } from "../../utils";

export async function getNotificationPermissionState() {
  if (Capacitor.getPlatform() !== "web") {
    try {
      const pushPermissionStatus = await PushNotifications.checkPermissions();
      captureSentryMessage("Notifications status: " + pushPermissionStatus.receive);
    } catch (error) {
      captureSentryMessage("Could not fetch notification permission: " + error, "error");
    }
  }
}
